export class State {
    constructor(value) {
        this.value = value;
        this.subs = new Set();
    }
    subscribe(sub) {
        if (!this.subs.has(sub)) {
            this.subs.add(sub);
            sub(this.value);
        }
        return () => this.subs.delete(sub);
    }
    set(value) {
        this.value = value;
        this.beat();
    }
    beat() {
        this.subs.forEach(sub => sub(this.value));
    }
}
